import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { useCurrentUserRole } from '~entities/users/hooks/use-current-user-role';

import { FamilyPaymentOverviewCard } from './family-payment-overview-card';
import { StudentByFamilyListTable } from './student-by-family-list-table';

export function StudentByFamilyListPage({ parentId }: { parentId: string }) {
  const { hasAdminAccess, isRolesReady } = useCurrentUserRole();
  const canViewFamilyBilling = isRolesReady && hasAdminAccess;

  return (
    <div className='w-full min-w-0 max-w-full overflow-x-clip overflow-y-visible pb-10'>
      <div className='min-w-0 px-4 pt-8 sm:px-10'>
        <header className='mb-8'>
          <img
            className='h-5 w-auto max-w-full'
            src={
              'https://storage.googleapis.com/msgsndr/VGZndtOFHrO4NIELBQYo/media/672ba39a6e8a940606bd75a8.svg'
            }
            alt='logo'
          />
        </header>
        <Link
          className='mb-2 flex min-w-0 items-center gap-2'
          to='/students'
          onClick={(e) => {
            e.preventDefault();
            history.back();
          }}
        >
          <CircleArrowLeft className='size-6 shrink-0' />
          <h2 className='min-w-0 text-lg font-semibold'>Back</h2>
        </Link>
      </div>
      <div className='min-w-0 border-t px-4 pt-8 sm:px-12'>
        {parentId && canViewFamilyBilling ? (
          <FamilyPaymentOverviewCard parentId={parentId} />
        ) : null}
        {parentId && <StudentByFamilyListTable parentId={parentId} />}
      </div>
    </div>
  );
}
